import { render } from "./NewTrainingForm.vue?vue&type=template&id=2d056562&scoped=true"
import script from "./NewTrainingForm.vue?vue&type=script&lang=js"
export * from "./NewTrainingForm.vue?vue&type=script&lang=js"

import "./NewTrainingForm.vue?vue&type=style&index=0&id=2d056562&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d056562"]])

export default __exports__